<template>
  <div class="menu-profile">
    <transition name="fade" mode="out-in">
      <div class="menu-profile__name" @click="openMenu()" :data-exclude="true">
        {{ user.fullName }}
      </div>
    </transition>
    <div class="menu-profile__icon" @click="openMenu()" :data-exclude="true">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="4"
        viewBox="0 0 8 4"
      >
        <g fill="none" fill-rule="evenodd">
          <g stroke="#FFF">
            <g>
              <g>
                <path
                  d="M0 0L3.187 3.687 6.373 0"
                  transform="translate(-1295 -47) translate(16 16) translate(1280 31)"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
    <transition name="fade" mode="out-in">
      <div class="menu-profile__nav" v-if="menu" v-click-outside="outside">
        <router-link
          class="menu-profile__nav__item"
          :to="{ name: 'corporateProfileEdit' }"
          >Kullanıcı Bilgileri</router-link
        >
        <router-link
          class="menu-profile__nav__item"
          :to="{ name: 'corporateProfileCompany' }"
          >Şirket Bilgileri</router-link
        >
        <!-- <router-link
          class="menu-profile__nav__item"
          :to="{ name: 'corporateProfileAuthorizedUsers' }"
          >Yetkili Kullanıcılar</router-link
        > -->
        <div class="menu-profile__nav__item">
          <form-button
            :text="'Oturumu Kapat'"
            @action="logout()"
            :size="'full'"
            :theme="'white'"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import * as API from "@/services/corporate/";
import { clickOutside } from "@/directives/";
export default {
  data() {
    return {
      menu: false,
      user: {},
    };
  },
  directives: {
    "click-outside": clickOutside,
  },
  watch: {
    $route() {
      this.menu = false;
    },
  },
  created() {
    this.getUser();
  },
  methods: {
    getUser: async function () {
      let vm = this;

      let response = await API.getUser();

      vm.user = response.result;
    },
    openMenu: function () {
      this.menu = !this.menu;
    },
    outside: function () {
      this.menu = false;
    },
    logout: function () {
      this.$store.dispatch("logout");
      this.$store
        .dispatch("deletechat")
        .then(() => this.$router.push({ name: "corporateLogin" }));
    },
  },
};
</script>